// extracted by mini-css-extract-plugin
module.exports = {"editor":"_398kzdx1UkhmdvVAFbaYJl","controls":"_3c9AfiRrMRhxpAVzIIENGd","styleButton":"_2OWT2Vl-SEBRGaHxwapiZl","activeButton":"_27VSpdEQKQwsAkkByfjwqp"};